<!--
 * @Description: 优秀企业列表
 * @Author: lz
 * @Date: 2021-07-20 13:46:28
 * @LastEditTime: 2021-10-21 16:18:53
 * @LastEditors: lz
-->
<template>
  <div class="policyDocuments">
    <div class="t">
      <a-tabs v-model="activeName">
        <a-tab-pane tab="优秀企业" key="policyDocuments"></a-tab-pane>
      </a-tabs>
      <!-- <div class="city">
        <span>所在地区：</span>
        <a-button type="link" class="padding_none">
          {{ listTreeCityObj.name }}
        </a-button>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isProjectCat }">
        <span class="title">企业类型：</span>
        <div>
          <span
            class="option_item"
            @click="changeProjectCat(item)"
            :class="{ active: projectCat_active == item.id }"
            v-for="(item, index) in projectCat"
            :key="index + 'policyArea'"
          >
            {{ item.name }}
          </span>
        </div>
        <a-button
          type="link"
          v-show="!isProjectCat"
          @click="isProjectCat = !isProjectCat"
        >
          更多
          <a-icon type="down" />
        </a-button>
        <a-button
          type="link"
          v-show="isProjectCat"
          @click="isProjectCat = !isProjectCat"
        >
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isPolicyArea }">
        <span class="title">注册资本：</span>
        <div>
          <span
            class="option_item"
            @click="changePolicyArea(item)"
            :class="{ active: policyArea_active == item.id }"
            v-for="(item, index) in policyArea"
            :key="index + 'policyArea'"
          >
            {{ item.name }}
          </span>
        </div>
        <a-button
          type="link"
          v-show="!isPolicyArea"
          @click="isPolicyArea = !isPolicyArea"
        >
          更多
          <a-icon type="down" />
        </a-button>
        <a-button
          type="link"
          v-show="isPolicyArea"
          @click="isPolicyArea = !isPolicyArea"
        >
          收起
          <a-icon type="up" />
        </a-button>
      </div>
      <div class="filter_item" :class="{ policyArea_more: !isAcceptDept }">
        <span class="title">行业类型：</span>
        <div>
          <span
            class="option_item"
            @click="changeAcceptDept(item)"
            :class="{ active: acceptDept_active == item.id }"
            v-for="(item, index) in acceptDept"
            :key="index + 'acceptDept'"
          >
            {{ item.name }}
          </span>
        </div>
        <a-button
          type="link"
          v-show="!isAcceptDept"
          @click="isAcceptDept = !isAcceptDept"
        >
          更多
          <a-icon type="down" />
        </a-button>
        <a-button
          type="link"
          v-show="isAcceptDept"
          @click="isAcceptDept = !isAcceptDept"
        >
          收起
          <a-icon type="up" />
        </a-button>
      </div> -->
    </div>
    <!-- <div class="line"></div> -->
    <div class="b" id="b">
      <div class="table">
        <a-table
          :loading="loading"
          row-key="key"
          :columns="columns"
          :data-source="tableData"
          :pagination="{
            pageSize: filterList.pageSize,
            current: filterList.pageNum,
            total: filterList.total,
            showQuickJumper: true, //显示跳转页数
            showSizeChanger: true, // 显示可改变每页数量
            pageSizeOptions: ['10', '20'], // 每页数量选项
            showTotal: (total) => `共 ${filterList.total} 条`, //显示总数
          }"
          @change="showSizeChange"
        >
          <template slot="info" slot-scope="text, record, index">
            <div class="table_wrapper">
              <!-- <img class="image" :src="record.company_logo" alt="" /> -->
              <div class="infoImage">
                <!-- v-if="record.abbreviation" -->
                <div
                  class="text"
                  :class="getRandomBgColor()"
                  v-if="record.abbreviation"
                >
                  {{ record.abbreviation.slice(0, 4) }}
                </div>
                <img
                  v-else
                  class="image"
                  src="@/assets/images/companyImage.jpg"
                  alt=""
                />
              </div>

              <div class="info">
                <div>
                  <div class="title">{{ record.enterprise_name }}</div>
                  <!-- <div class="lable">{{ record.status }}</div> -->
                </div>
                <div class="list_box">
                  <div
                    v-for="(item, index) in record.lable"
                    :key="index"
                    class="list_item"
                  >
                    <span @click="redirect(item)">{{ item }}</span>
                  </div>
                </div>
                <div class="detail flex">
                  <span
                    ><span>法定代表人：</span>{{ record.legal_person }}</span
                  >
                  <!-- <span><span>注册资本：</span></span> -->
                  <span><span>成立日期：</span>{{ record.register_date }}</span>
                  <span class="date"> </span>
                </div>
                <!-- <div class="detail flex">
                  <span><span>电话：</span></span>
                  <span><span>邮箱：</span></span>
                  <span class="date"> </span>
                </div> -->
                <div class="detail">
                  <span><span>行业：</span>{{ record.industry }}</span>
                </div>
                <div class="detail bottom_0">
                  <span><span>地址：</span>{{ record.district }}</span>
                </div>
              </div>
              <div class="svg-wrapper">
                <svg-icon :iconClass="getLogoColor(index)"></svg-icon>
                <!-- <svg-icon
                  iconClass="enterprise-logo-yellow"
                  v-if="index === 0"
                ></svg-icon>
                <svg-icon
                  iconClass="enterprise-logo-cyan"
                  v-else-if="index === 1"
                ></svg-icon>
                <svg-icon
                  iconClass="enterprise-logo-violet"
                  v-else-if="index === 2"
                ></svg-icon>
                <svg-icon iconClass="enterprise-logo-blue" v-else></svg-icon> -->
              </div>
            </div>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getExcellentEnterprisesList } from "../../api/excellentCompany";
const columns = [
  {
    // title: "企业信息",
    scopedSlots: { customRender: "info" },
  },
  // {
  //   title: "所属榜单",
  //   ellipsis: true,
  //   scopedSlots: { customRender: "list" },
  // },
];

export default {
  name: "ExcellentCompany",
  data() {
    return {
      tableHeight: 360,
      tableData: [],
      // treeCityList: [],
      // listTreeCityObj: {
      //   name: "",
      //   id: "",
      // },
      columns,
      activeName: "policyDocuments",
      // loading: false,
      // isPolicyArea: false,
      // isProjectCat: false,
      // isAcceptDept: false,
      filterList: {
        key: "",
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      // policyArea: [
      //   {
      //     id: 0,
      //     name: "全部",
      //   },
      //   {
      //     id: 1,
      //     name: "部委项目",
      //   },
      //   {
      //     id: 2,
      //     name: "北京市",
      //   },
      // ],
      // policyArea_active: "",
      // projectCat: [
      //   {
      //     id: 0,
      //     name: "全部",
      //   },
      //   {
      //     id: 1,
      //     name: "申报通知",
      //   },
      //   {
      //     id: 2,
      //     name: "公示公告",
      //   },
      //   {
      //     id: 3,
      //     name: "政策法规",
      //   },
      // ],
      // projectCat_active: "",
      // acceptDept: [
      //   {
      //     id: 0,
      //     name: "全部",
      //   },
      //   {
      //     id: 1,
      //     name: "北京市商务局",
      //   },
      //   {
      //     id: 2,
      //     name: "北京市经济和信息化局",
      //   },
      // ],
      // acceptDept_active: "",
    };
  },
  methods: {
    // 获取列表数据
    async getTableData() {
      this.loading = true;
      const res = await getExcellentEnterprisesList({
        ...this.filterList,
      }).catch(() => {
        this.loading = false;
      });
      this.loading = false;
      if (res.code == 0) {
        res.data.list.map((item, index) => {
          item.key = index;
        });
        this.tableData = res.data.list;

        this.filterList.total = res.data.total;
      }
    },
    showSizeChange({ current, pageSize }) {
      this.filterList.pageNum = current;
      this.filterList.pageSize = pageSize;
      this.getTableData();
    },

    redirect(text) {
      this.filterList.key = text;
      this.getTableData();
    },
    getTableHeight() {
      let timer;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.tableHeight =
          document.documentElement.clientHeight -
          document.getElementById("b").offsetTop -
          165;
      }, 60);
    },
    //企业图片随即背景色
    getRandomBgColor() {
      var bgColorList = [
        "img-blue-1",
        "img-blue",
        "img-purple",
        "img-khaki",
        "img-cyan",
      ];
      var bgColor = bgColorList[Math.floor(Math.random() * bgColorList.length)];
      return bgColor;
    },
    //logo背景色
    getLogoColor(index) {
      let str = "enterprise-logo-blue";
      switch (index) {
        case 0:
          str = "enterprise-logo-yellow";
          break;
        case 1:
          str = "enterprise-logo-cyan";
          break;
        case 2:
          str = "enterprise-logo-violet";
          break;
      }
      return str;
    },
  },
  created() {
    this.filterList.key = this.$route.query.key;
    this.getTableData();
    // this.$nextTick(() => {
    //   this.getTableHeight();
    // });
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.$once("hook:destroyed", () => {
      window.removeEventListener("resize", this.getTableHeight);
    });
  },
};
</script>
<style lang="less" scoped>
@bgColor: #fff;
.padding_none {
  padding: 0;
}
.text_tag {
  color: red;
}
.line {
  height: 10px;
  width: auto;
  background: #eff2f5;
}
.cursor {
  cursor: pointer;
}
.policyDocuments {
  height: 100%;
  // padding: 10px;
  .t {
    background-color: @bgColor;
    padding: 0 20px;
  }
  .line {
    height: 10px;
    background: #eff2f5;
  }
  .b {
    background-color: @bgColor;
    padding: 0px 20px 0 20px;
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .table {
      .table_wrapper {
        display: flex;
        align-items: center;
        padding: 24px 0;
        .infoImage {
          margin-right: 20px;
          height: 140px;
          width: 140px;
          display: table-cell;
          text-align: center;
          vertical-align: middle;
          .text {
            text-align: justify;
            text-justify: distribute-all-lines;
            text-align-last: justify; //兼容
            padding: 20px;
            height: 100%;
            background-color: #8ba3cd;
            border: 1px solid #f4f4f4;
            font-size: 30px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            letter-spacing: 10px;
            padding-left: 30px;
            line-height: 50px;
            &.img-blue-1 {
              background-color: #8ba3cd;
            }
            &.img-blue {
              background-color: #7db4d8;
            }

            &.img-purple {
              background-color: #bc9edd;
            }

            &.img-khaki {
              background-color: #d0ae9d;
            }

            &.img-cyan {
              background-color: #84cab0;
            }
          }
          img {
            height: 150px;
            width: 150px;
            border: 1px solid #f9f9f9;
          }
        }
        .info {
          // width: 720px;
          flex: 1;
          .title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #333333;
            margin-bottom: 18px;
            display: inline-block;
            height: 16px;
          }
          .lable {
            display: inline-block;
            margin-left: 10px;
          }
          .detail {
            margin-bottom: 14px;
            height: 14px;
            line-height: 14px;

            &.flex {
              display: flex;
            }
            span {
              text-align: left;
              width: 50%;
              color: #333333;
              font-size: 14px;
              span {
                color: #666666;
              }
            }
          }
          .bottom_0 {
            margin-bottom: 0px;
          }
          .list_box {
            display: flex;
            flex-wrap: wrap;
            .list_item {
              margin-right: 20px;
              margin-bottom: 14px;
              > span {
                display: inline-block;
                cursor: pointer;
                padding: 0 6px;
                background: rgba(0, 114, 247, 0.05);
                height: 22px;
                font-size: 12px;
                font-family: PingFang-SC-Medium, PingFang-SC;
                font-weight: 500;
                color: #0072f7;
                line-height: 22px;
              }
            }
          }
        }
        .svg-wrapper {
          width: 21px;
          height: 26px;
          align-self: flex-start;
          .svg-icon {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  ::v-deep .ant-table-pagination.ant-pagination {
    margin-bottom: 5px;
  }
  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
    padding: 12px 0;
  }

  ::v-deep .ant-tabs-bar {
    margin: 0;
  }

  ::v-deep .ant-tabs-ink-bar {
    width: 64px;
    background-color: #0072f7;
  }
  .city {
    margin-bottom: 26px;
    height: 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
    .ant-btn {
      color: #0072f7;
      height: 14px;
      line-height: 14px;
    }
  }
  .filter_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0px;
    &.policyArea_more {
      height: 24px;
      margin-bottom: 15px;
      overflow: hidden;
    }
    .title {
      width: 70px;
      line-height: 24px;
    }
    div {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      .option_item {
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 15px;
        padding: 0px 10px;
        cursor: pointer;
        //min-width: 76px;
        text-align: center;
      }
    }
    ::v-deep .ant-btn > .anticon + span,
    .ant-btn > span + .anticon {
      margin-left: 4px;
    }
    .ant-btn-link {
      color: #0072f7;
    }
    ::v-deep .ant-btn {
      color: #999;
      width: 80px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
    // span:nth-child(2) {
    //   margin-left: 10px;
    // }
    .more {
      // float: right;
      font-size: 14px;
      font-weight: 400;
      color: #999;
      cursor: pointer;
    }
    .more::after {
      content: "";
      display: inline-block;
      width: 7px;
      height: 7px;
      margin-left: 5px;
      transform: rotate(45deg);
      border-right: 1px solid #999;
      border-bottom: 1px solid #999;
      vertical-align: 2px;
    }
    .active {
      height: 24px;
      line-height: 24px;
      background: #0072f7;
      border-radius: 4px;
      color: @bgColor;
    }
  }
}

::v-deep .ant-table-thead > tr > th {
  display: none;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 14px;
  padding: 12px 16px;
  // text-align: center;
  // &:first-child {
  //   width: 70%;
  // }
}
::v-deep .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f0f0f0;
  padding: 0;
  // &:first-child {
  //   width: 70%;
  // }
}

::v-deep
  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  td {
  background: unset !important;
}
</style>
